import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  SuppliesWorkspace,
  type SuppliesWorkspaceProps,
} from "@/features/staff/inventory/supplies-workspace"

export default function StaffLocationManageSuppliesIndex(props: SuppliesWorkspaceProps) {
  return (
    <StaffLayout>
      <SuppliesWorkspace {...props} />
    </StaffLayout>
  )
}
